import React, { useEffect, useRef, useState } from "react";

import { FormButton } from "components";
import { FormikSelectInput, FormikTextInput } from "components/UI/Inputs/FormikInputs";
import { Form, Formik } from "formik";
import * as yup from "yup";

import { useRecoilValue, useSetRecoilState } from "recoil";
import {
    snackbarData,
    userCredentials,
} from "recoilState/GlobalState";

import styles from "styles/pages/ModalActions.module.scss";
import { RNHAreaUpd } from "services/services-mia/RNHAreaUpd";
import { RNHAreaGet } from "services/services-mia/RNHAreaGet";
import wellknown from "wellknown";

const wktPolygonSchema = yup.string()
    .required("Debe ingresar las coordenadas WKT")
    .test('valid-wkt-format', 'Formato de coordenadas inválido', function(value) {
        if (!value || !value.trim()) {
            return this.createError({ message: 'Ingrese las coordenadas' });
        }
        const wktString = `POLYGON((${value.trim()}))`;
        const parsed = wellknown.parse(wktString);
        
        if (!parsed) {
            return this.createError({ 
                message: 'El formato de las coordenadas no es válido'
            });
        }
        if (parsed.type !== 'Polygon') {
            return this.createError({ 
                message: 'Las coordenadas no forman un polígono válido'
            });
        }
        const coords = parsed.coordinates[0];
        if (coords.length < 4) {
            return this.createError({ 
                message: `Se requieren mínimo 4 coordenadas. Tienes ${coords.length - 1}.`
            });
        }
        return true;
    });

export default function UpdateModal({ updateList, user, closeModal, filtro }) {
    const setSnackBarInfo = useSetRecoilState(snackbarData);
    const [zonas, setZonas] = useState(filtro);
    const credentials = useRecoilValue(userCredentials);
    const formikRef = useRef();
    const [data, setData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [inRequest, setInRequest] = useState(false);

    const getArticulosData = async () => {
        setIsLoading(true);
        const result = await RNHAreaGet(credentials, { areaId: user.id })
        console.log(result)
        formikRef.current.setValues({
            id: result[0].rnhAreaId,
            nombre: result[0].rnhAreaNombre,
            cod: result[0].rnhAreaCod,
            zonaId: result[0].rnhAreaZonaId,
            wkt: result[0].rnhAreaWKT,
            version: result[0].rnhAreaVersion,
        });
        setData(result[0]);
        setIsLoading(false);
    }
    const handleUpdArea = async (values) => {
        const response = await RNHAreaUpd(credentials, {
            id: data.rnhAreaId,
            cod: values.cod,
            name: values.nombre,
            version: data.rnhAreaVersion,
            zonaId: values.zonaId,
            wkt: values.wkt,
        })
        if (response.length === 0) {
            setSnackBarInfo({
                message: "Area modificada correctamente",
                severity: "success",
                open: true,
            });
            formikRef.current.resetForm();
            updateList();
            closeModal();
        }
    };
    useEffect(() => {
        getArticulosData()
    }, []);
    return (
        <Formik
            innerRef={formikRef}
            initialValues={{
                nombre: "",
                zonaId: "",
                cod: "",
                wkt: ""
            }}
            validationSchema={
                yup.object({
                    nombre: yup.string("Debe ingresar un nombre").max(45, "Debe tener menos de 45 caracteres").required("Debe ingresar un nombre"),
                    zonaId: yup.string("Debe seleccionar una zona").required("Debe ingresar una zona"),
                    cod: yup.string("Debe ingresar un Código").required("Debe ingresar un Código"),
                    wkt: wktPolygonSchema,
                })
            }
            onSubmit={(values) => {
                handleUpdArea(values);
            }}
        >
            <Form className={styles.inputs} noValidate>
                <div className={styles["column"]}>
                    <>
                        <FormikSelectInput
                            fullWidth={true}
                            name="zonaId"
                            labelText="Zona"
                            onChange={(e) => {
                                formikRef.current.setFieldValue("zonaId", e.target.value);
                            }}
                        >
                            <option value="" selected disabled >Seleccione</option>
                            {zonas.map(({ rnhZonaId, rnhZonaNombre }) => (
                                <option
                                    key={rnhZonaId}
                                    data-id={rnhZonaId}
                                    value={rnhZonaId}
                                >
                                    {rnhZonaNombre}
                                </option>
                            ))}
                        </FormikSelectInput>
                        <FormikTextInput
                            fullWidth={true}
                            name="nombre"
                            placeholder=""
                            labelText="Nombre del area"
                        />
                        <FormikTextInput
                            fullWidth={true}
                            name="cod"
                            placeholder=""
                            labelText="Código del area"
                        />
                        <FormikTextInput
                            fullWidth={true}
                            name="wkt"
                            placeholder=""
                            labelText="Poligono (Wkt)"
                            multiline
                        />
                    </>
                    <FormButton
                        inRequest={inRequest}
                        newFormData={{ button: "Guardar cambios" }}
                        onCloseModal={closeModal}
                    />
                </div>
            </Form>
        </Formik>
    );
}
